"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Radek Beran
 */

var ReleaseAction;

(function (ReleaseAction) {
  ReleaseAction["Edit"] = "edit";
  ReleaseAction["AbandonEdit"] = "abandonEdit";
  ReleaseAction["Approve"] = "approve";
  ReleaseAction["Reject"] = "reject";
  ReleaseAction["Cancel"] = "cancel";
  ReleaseAction["Delay"] = "delay";
  ReleaseAction["Recalculate"] = "recalculate";
  ReleaseAction["PrepareExport"] = "prepareExport";
  ReleaseAction["AbandonExportPreparation"] = "abandonExportPreparation";
  /** Start export of release. */

  ReleaseAction["Export"] = "export";
})(ReleaseAction = exports.ReleaseAction || (exports.ReleaseAction = {}));